function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m201.98 297.18c-2.786 0-9.259-1.261-9.259-13v-53.882h-178.33c-0.493 0.078-1.156 0.15-1.937 0.15-3.173 0-6.101-1.201-8.245-3.404-2.791-2.852-4.206-7.212-4.206-12.953v-82.82c0-11.458 8.122-14.48 12.421-14.48h176.54v-49.384c0-13.805 6.569-15.865 10.496-15.865 6.281 0 12.538 5.972 13.727 7.176 4.294 3.167 117.85 88.778 130.33 101.24 4.528 4.537 5.333 9.101 5.206 12.124-0.3 7.274-5.908 12.223-6.539 12.775l-126.3 104.52c-1.386 1.5-7.799 7.799-13.895 7.799z"
});

var SvgRightArrow = function SvgRightArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: "100px",
    height: "auto",
    viewBox: "0 0 348.728 348.728",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-arrow.dbe816ad.svg";
export { ForwardRef as ReactComponent };